// Design tokens do Indlus — fonte única de cores, tipografia e forma.
// Derivados do logótipo (azul-marinho + turquesa); ver docs/ux-redesign-brief.md §4.1
// e docs/ux-audit/AUDIT.md (A6) para os dois ajustes de contraste face ao briefing.

export const brand = {
  navy900: '#0B2545', // marca, botão primário, cartão de saldo
  navy700: '#163A60', // superfícies escuras secundárias
  teal500: '#0FA3B1', // acento, gráficos, ícone activo (só não-texto: 3,05:1 em branco)
  teal700: '#0B6F7A', // links e texto de acento (5,88:1 em branco)
  teal50: '#E8F4F6', // fundo do item activo
} as const

export const surface = {
  app: '#F5F7FA', // fundo da aplicação
  paper: '#FFFFFF', // cartões
  subtle: '#F8FAFC', // linhas alternadas, cabeçalhos de tabela, hover suave
  border: '#E4E8EE', // bordas de cartões e divisores (decorativo)
  borderInput: '#7D8A9C', // borda de inputs — 3,51:1 em branco (WCAG 1.4.11 pede 3:1)
} as const

export const text = {
  primary: '#0F1B2D',
  secondary: '#5B6B7F', // 5,45:1 em branco, 5,08:1 no fundo da app
} as const

/**
 * Pares {texto, fundo} das etiquetas de estado — todos AA (≥4,5:1) a 12 px.
 * O briefing dava `#157F4A` ao sucesso, que fica nos 4,49:1 sobre `#E7F5EE`.
 */
export const status = {
  success: { fg: '#137A47', bg: '#E7F5EE' }, // pago, entregue, ao vivo
  warning: { fg: '#9A3F0B', bg: '#FDEEE3' }, // atraso, dívida, prazo
  danger: { fg: '#B42318', bg: '#FEECEB' }, // remover, bloquear, erro
  neutral: { fg: '#2E4A6B', bg: '#EEF2F6' }, // emitido, pendente
  info: { fg: '#0B6F7A', bg: '#E8F4F6' }, // informativo, em curso
  muted: { fg: '#4B5563', bg: '#F1F3F6' }, // inactivo, arquivado, cancelado
} as const

export type StatusVariant = keyof typeof status

export const fontFamily = '"Manrope", "Segoe UI", system-ui, sans-serif'

export const radius = {
  control: 12, // botões e inputs
  card: 16, // cartões
  chip: 8,
} as const

/** Altura mínima de botões e alvo de toque mínimo (WCAG 2.5.5 / briefing). */
export const TOUCH_TARGET = 44
